var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRekreacja(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04688 5.04653C5.41724 3.96725 6.10811 3.03197 7.02376 2.37028C7.93941 1.7086 9.03448 1.35327 10.1574 1.35352H16.7478C17.8707 1.35347 18.9658 1.70887 19.8816 2.37053C20.7973 3.03217 21.4884 3.96732 21.8592 5.04653",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9305 4.16992H7.97385C6.53836 4.1704 5.16183 4.75141 4.14704 5.78518C3.13223 6.81895 2.56228 8.22078 2.5625 9.68244V12.8407C2.5625 14.3026 3.13278 15.7046 4.1479 16.7383C5.16303 17.7721 6.53987 18.3529 7.97559 18.3532H8.88859C9.32314 18.3576 9.75352 18.2676 10.1512 18.0894C10.5489 17.9111 10.9046 17.6484 11.1947 17.3191C11.472 16.996 11.8139 16.7373 12.1976 16.5601C12.5813 16.3829 12.9978 16.2915 13.4191 16.292C13.8404 16.2915 14.2569 16.3829 14.6406 16.5601C15.0243 16.7373 15.3662 16.996 15.6435 17.3191C15.9334 17.6484 16.289 17.911 16.6865 18.0893C17.084 18.2676 17.5143 18.3576 17.9487 18.3532H18.9305C20.3662 18.3529 21.743 17.7721 22.7581 16.7383C23.7733 15.7046 24.3435 14.3026 24.3435 12.8407V9.68244C24.3436 8.95856 24.2037 8.24176 23.9317 7.57296C23.6598 6.90415 23.261 6.29645 22.7584 5.78456C22.2557 5.27266 21.659 4.8666 21.0022 4.58955C20.3453 4.31252 19.6414 4.16992 18.9305 4.16992Z",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62469 13.6959C2.14544 13.5026 1.7343 13.167 1.44459 12.7329C1.15489 12.2987 1 11.7859 1 11.261C1 10.7362 1.15489 10.2233 1.44459 9.78921C1.7343 9.355 2.14544 9.01956 2.62469 8.82617",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3438 9.2334C24.8231 9.4267 25.2341 9.76222 25.5239 10.1964C25.8136 10.6306 25.9685 11.1433 25.9685 11.6682C25.9685 12.1931 25.8136 12.7059 25.5239 13.1401C25.2341 13.5742 24.8231 13.9097 24.3438 14.1031",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRekreacja);
export default __webpack_public_path__ + "static/media/rekreacja.36872fc8befe873fbd4bd7d886137a68.svg";
export { ForwardRef as ReactComponent };